import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTableWidgetStyles = () => {
  return StyleSheet.create({
    subActionContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end'
    },
    bottomButtonContainer: {
      paddingTop: tokens.spacing.SPACING_16
    },
    filterContainerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      flexDirection: 'row',
      zIndex: 1
    },
    buttonWidgetStyle: {
      alignSelf: 'center',
      marginLeft: tokens.spacing.SPACING_20
    },
    searchContainerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      marginLeft: 'auto'
    },
    endButtonWidgetStyle: {
      paddingBottom: tokens.spacing.SPACING_16
    }
  });
};
export var getDropdownWidgetStyles = () => {
  return StyleSheet.create({
    dropdownContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      zIndex: 1
    },
    dropdownWrapper: {
      paddingBottom: tokens.spacing.SPACING_16,
      paddingLeft: tokens.spacing.SPACING_8,
      maxWidth: '263px'
    },
    dropdownMenuStyle: {
      top: '45px',
      minWidth: '207px'
    },
    dropdownStyle: {
      minWidth: '100px'
    },
    childDropdownStyle: {
      flexShrink: 1
    }
  });
};